import { create } from 'zustand'

const CategoryState = create<CategoryStateInterface>((set) => {
    const CategoryInitialState: CategoryStateInterface = {
        Categories: [],
        Loading: false,
        SetState: (payload: CategoryInterface) => set((state: CategoryStateInterface) => ({
            ...state,
            ...payload
        }))
    }

    return CategoryInitialState
})

export default CategoryState
